<div class="protect-workspace">
  <nz-layout>
    <nz-header class="protect-header" style="color: black">
      {{ "Protect MedSAM Segmentation" | translate }}

      <div class="protect-header-stats" *ngIf="dicomFrames.length > 0">
        <span
          >{{ "Frame" | translate }} {{ activeFrameIndex + 1 }} /
          {{ dicomFrames.length }}</span
        >
        <span
          >{{ "Boxes" | translate }} {{ readyFrameCount }} /
          {{ dicomFrames.length }}</span
        >
        <span
          >{{ "Segmented" | translate }} {{ segmentedFrameCount }} /
          {{ dicomFrames.length }}</span
        >
      </div>
    </nz-header>

    <nz-content class="protect-content">
      <section class="record-bar">
        <nz-select
          class="record-select"
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'Select Imaging Record' | translate"
          [nzOptions]="imagingRecords"
          [(ngModel)]="selectedImaging"
          (ngModelChange)="onImagingSelected($event)"
          [disabled]="
            !hasPermission(['a-mss']) ||
            isExamLoading ||
            isSubmitting ||
            isReconstructing
          "
        ></nz-select>

        <div class="record-actions" *hasAddPermissions="['a-mss']">
          <button
            nz-button
            nzType="primary"
            (click)="segment()"
            [disabled]="!canSegment"
            [nzLoading]="isSubmitting"
          >
            <span nz-icon nzType="scissor" nzTheme="outline"></span>
            {{ "Segment Stack" | translate }}
          </button>

          <!-- <button
            nz-button
            (click)="reconstructDicoms()"
            [disabled]="!canReconstructDicoms"
            [nzLoading]="isReconstructing"
          >
            <span nz-icon nzType="cloud-download" nzTheme="outline"></span>
            {{ "Reconstruct DICOMs" | translate }}
          </button> -->

          <button nz-button nzType="default" (click)="openHdrbtSimulationModal()">
            <span nz-icon nzType="play-circle" nzTheme="outline"></span>
            Run HDRBT Simulation
          </button>
        </div>
      </section>

      @if (isImagingLoading || isExamLoading) {
        <div class="viewer-loading">
          <nz-spin nzSimple></nz-spin>
          <span>{{ loadingMessage | translate }}</span>
        </div>
      }

      @if (!selectedImaging && !isImagingLoading) {
        <div class="protect-empty-state">
          {{ "Select an imaging record to load the DICOM viewer." | translate }}
        </div>
      }

      @if (loadError && !isExamLoading) {
        <div class="protect-error-state">
          <div>{{ loadError | translate }}</div>
          <div class="protect-error-debug" *ngIf="loadDiagnostics.length > 0">
            <div class="protect-error-debug-title">Diagnostics:</div>
            <ul>
              <li *ngFor="let detail of loadDiagnostics">{{ detail }}</li>
            </ul>
          </div>
        </div>
      }

      @if (selectedImaging && dicomFrames.length > 0) {
        <section class="viewer-stage">
          <section class="tool-strip">
            <div class="tool-group">
              <button
                nz-button
                nz-tooltip
                [nzTooltipTitle]="'Window and level' | translate"
                [class.active]="activeTool === 'window'"
                (click)="selectTool('window')"
              >
                <span nz-icon nzType="column-width" nzTheme="outline"></span>
                {{ "Window" | translate }}
              </button>

              <button
                nz-button
                nz-tooltip
                [nzTooltipTitle]="'Pan image' | translate"
                [class.active]="activeTool === 'pan'"
                (click)="selectTool('pan')"
              >
                <span nz-icon nzType="drag" nzTheme="outline"></span>
                {{ "Pan" | translate }}
              </button>

              <button
                nz-button
                nz-tooltip
                [nzTooltipTitle]="'Zoom image' | translate"
                [class.active]="activeTool === 'zoom'"
                (click)="selectTool('zoom')"
              >
                <span nz-icon nzType="zoom-in" nzTheme="outline"></span>
                {{ "Zoom" | translate }}
              </button>

              <button
                nz-button
                nz-tooltip
                [nzTooltipTitle]="'Rotate image' | translate"
                [class.active]="activeTool === 'rotate'"
                (click)="selectTool('rotate')"
              >
                <span nz-icon nzType="rotate-right" nzTheme="outline"></span>
                {{ "Rotate" | translate }}
              </button>

              <button
                nz-button
                nz-tooltip
                [nzTooltipTitle]="'Draw bounding box' | translate"
                [class.active]="activeTool === 'box'"
                (click)="selectTool('box')"
              >
                <span nz-icon nzType="border" nzTheme="outline"></span>
                {{ "Box" | translate }}
              </button>
            </div>

            <div class="tool-group">
              <button nz-button (click)="resetViewer()">
                <span nz-icon nzType="reload" nzTheme="outline"></span>
                {{ "Reset" | translate }}
              </button>

              <button nz-button (click)="toggleInvert()">
                <span nz-icon nzType="eye-invisible" nzTheme="outline"></span>
                {{ "Invert" | translate }}
              </button>

              <button
                nz-button
                (click)="clearCurrentBox()"
                [disabled]="!activeFrame?.box"
              >
                <span nz-icon nzType="delete" nzTheme="outline"></span>
                {{ "Clear Frame" | translate }}
              </button>

              <button
                nz-button
                nzDanger
                (click)="clearAllBoxes()"
                [disabled]="readyFrameCount === 0"
              >
                <span nz-icon nzType="clear" nzTheme="outline"></span>
                {{ "Clear All" | translate }}
              </button>
            </div>
          </section>

          <section class="viewer-panel">
            <div class="viewer-status">
              <div>
                <div class="frame-name">{{ activeFrame?.fileName }}</div>
                <div class="frame-meta">
                  {{ activeFrame?.columns }} x {{ activeFrame?.rows }}
                  <span *ngIf="activeFrame?.box">
                    - {{ "Box" | translate }}: {{ activeFrame?.box?.x1 }},
                    {{ activeFrame?.box?.y1 }}
                    -
                    {{ activeFrame?.box?.x2 }}, {{ activeFrame?.box?.y2 }}
                  </span>
                </div>
              </div>

              <div
                class="frame-state"
                [class.ready]="activeFrame?.box"
                [class.error]="activeFrame?.segmentError"
              >
                @if (activeFrame?.segmentError) {
                  {{ "Unable to segment" | translate }}
                } @else if (activeFrame?.box) {
                  {{ "Bounding box ready" | translate }}
                } @else {
                  {{
                    "Select Box, then draw one rectangle on this frame"
                      | translate
                  }}
                }
              </div>
            </div>

            <div #dicomViewport class="cornerstone-viewport"></div>

            <div class="frame-controls">
              <button
                nz-button
                nzShape="circle"
                (click)="goToFrame(activeFrameIndex - 1)"
                [disabled]="activeFrameIndex === 0"
              >
                <span nz-icon nzType="left" nzTheme="outline"></span>
              </button>

              <input
                class="frame-slider"
                type="range"
                min="1"
                [max]="dicomFrames.length"
                [value]="activeFrameIndex + 1"
                (input)="frameSliderChange($event)"
              />

              <button
                nz-button
                nzShape="circle"
                (click)="goToFrame(activeFrameIndex + 1)"
                [disabled]="activeFrameIndex === dicomFrames.length - 1"
              >
                <span nz-icon nzType="right" nzTheme="outline"></span>
              </button>

              <nz-pagination
                [nzPageIndex]="activeFrameIndex + 1"
                [nzTotal]="dicomFrames.length"
                [nzPageSize]="1"
                (nzPageIndexChange)="goToFrame($event - 1)"
                nzSimple
              ></nz-pagination>
            </div>
          </section>
        </section>

        <section class="result-stack">
          <div class="result-panel">
            <div class="result-heading">
              <span>{{ "Prediction Mask" | translate }}</span>
              <span>{{ "Frame" | translate }} {{ activeFrameIndex + 1 }}</span>
            </div>

            <div class="result-viewport">
              @if (activeFrame?.isLoading && !activeFrame?.result) {
                <div class="result-message">
                  <nz-spin nzSimple></nz-spin>
                </div>
              } @else if (activeMaskSrc) {
                <img nz-image class="result-img" [nzSrc]="activeMaskSrc" />
              } @else {
                <div class="result-message">
                  {{ "No mask result for this frame yet" | translate }}
                </div>
              }
            </div>
          </div>

          <div class="result-panel">
            <div class="result-heading">
              <span>{{ "Overlay" | translate }}</span>
              <span>{{ "Frame" | translate }} {{ activeFrameIndex + 1 }}</span>
            </div>

            <div class="result-viewport">
              @if (activeFrame?.isLoading && !activeFrame?.result) {
                <div class="result-message">
                  <nz-spin nzSimple></nz-spin>
                </div>
              } @else if (activeOverlaySrc) {
                <img nz-image class="result-img" [nzSrc]="activeOverlaySrc" />
              } @else {
                <div class="result-message">
                  {{ "No overlay result for this frame yet" | translate }}
                </div>
              }
            </div>
          </div>
        </section>
      }
    </nz-content>
  </nz-layout>

  <nz-modal
    [nzVisible]="isHdrbtSimulationModalVisible"
    nzTitle="Run HDRBT Simulation"
    [nzFooter]="null"
    [nzWidth]="960"
    (nzOnCancel)="closeHdrbtSimulationModal()"
  >
    <ng-container *nzModalContent>
      @if (isHdrbtSimulationModalVisible) {
        <video
          class="hdrbt-simulation-video"
          src="assets/videos/protect-output.mp4"
          controls
          autoplay
        ></video>
      }
    </ng-container>
  </nz-modal>
</div>
